import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[];
    model$: any;
    public menuVisible: boolean;
    constructor(private menu: MenuServiceInt) {
    }

    ngOnInit() {
        this.model$ = this.menu.items$.subscribe((success) => {
            this.model = success;
            this.menuVisible = this.menu.menuVisible;
        });
        if (this.menu.loaded === true) {
            this.model = this.menu.items;
            this.menuVisible = this.menu.menuVisible;
        }
   }

    ngOnDestroy() {
        this.model$.unsubscribe();
    }    
}
